import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export const Lightbox = ({ src, alt = "", onClose }) => {
  useEffect(() => {
    if (!src) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [src, onClose]);
  if (!src) return null;
  return createPortal(
    <div className="fixed inset-0 z-[3000] bg-black/90 backdrop-blur-sm flex items-center justify-center p-3 cursor-zoom-out" onClick={onClose} role="dialog" aria-modal="true" data-testid="lightbox">
      <button type="button" onClick={onClose} aria-label="Close" className="absolute top-3 right-3 rounded-full bg-white/15 hover:bg-white/30 text-white p-2 transition-colors" data-testid="lightbox-close"><X className="h-6 w-6" /></button>
      <img src={src} alt={alt} className="max-h-[92vh] max-w-[96vw] object-contain rounded-lg shadow-2xl" data-testid="lightbox-image" />
      <p className="absolute bottom-3 text-white/70 text-xs">Tap anywhere to close</p>
    </div>,
    document.body
  );
};

export default Lightbox;
